import React from 'react';
import './ButtonAdditional.css';

const ButtonAdditional = ({ children, className = '', type = 'button', onClick, disabled = false, ariaLabel }) => {
	return (
		<button
			type={type}
			className={`btn-additional ${className}`}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
		>
			{children}
		</button>
	);
};

export default ButtonAdditional;
